import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handleDeleteItem } from "./HandleDeleteFunction";
import { SelectInput, InputField } from "../../blueplanitUtils/InputField";
import { setClientHistorys } from "../../Slices/employeeslice";
import { getAllClientsData } from "../../Slices/loginUserSlice";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import Modal from "../../blueplanitUtils/Modal";
import { handleClose } from "./HandleClosePop/handleclose";
import { SetAllEmployees } from "../../Slices/employeeslice";
import { getOptionsByPath } from "../../utilsdata";
import { CLIENT_INFO, CLIENT_SERVICESASSIGNED } from "../../Dropdownmanager";
export const ClientModelpopup = () => {
  const { handleSubmit } = useFormHandler();
  const dispatch = useDispatch()
  const { Empid } = useParams()
  const [clientHistory, setClientHistory] = useState([]);
  const [clientErrors, setClientErrors] = useState({});
  const [ClientFormValid, setClientFormValid] = useState(false);
  const Client = useSelector((state) => state.employee.clientHistory);
  const clientOptions = useSelector(state => state.clients.clients);
  const AllEmployees = useSelector((state) => state.employee.AllEmployees);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  useEffect(() => {
  if (Array.isArray(Client)) {
    const normalized = Client.map(client => ({
      ...client,
      processes: typeof client.processes === "string"
        ? client.processes.split(",").map(p => p.trim())
        : Array.isArray(client.processes)
          ? client.processes
          : []
    }));
    setClientHistory(normalized);
  } else {
    setClientHistory([]);
  }
}, [Client]);


  const validateClient = (clients) => {
    const errors = {};
    const alphaRegex = /^[A-Za-z\s-]+$/;
    const numericRegex = /^\d+$/;

    clients.forEach((client, index) => {
      const clientErrors = {};

      if (!client.NameOfClient) {
        clientErrors.NameOfClient = "Name is required";
      }
      if (!Array.isArray(client.processes) || client.processes.length === 0) {
  clientErrors.processes = "At least one process is required";
}

      if (!client.role?.trim()) {
        clientErrors.role = "Role is required";
      } else if (!alphaRegex.test(client.role)) {
        clientErrors.role = "Role must contain only letters";
      }

      if (!client.SlotNo?.trim()) {
        clientErrors.SlotNo = "Slot No is required";
      } else if (!numericRegex.test(client.SlotNo)) {
        clientErrors.SlotNo = "Slot No must be numeric";
      }

      if (Object.keys(clientErrors).length > 0) {
        errors[index] = clientErrors;
      }
    });

    return errors;
  };
  const handleClientChange = (index, e) => {
    const { name, value } = e.target;

    const updatedClients = [...clientHistory];
    updatedClients[index] = { ...updatedClients[index], [name]: value };
    setClientHistory(updatedClients);
    const newErrors = validateClient(updatedClients);
    setClientErrors(newErrors);
    const allFieldsValid = updatedClients.every((client) =>
  client.NameOfClient &&
  Array.isArray(client.processes) &&
  client.processes.length > 0 &&
  client.role?.trim() &&
  client.SlotNo?.trim()
);

setClientFormValid(allFieldsValid);

  };

  const addClient = () => {
    setClientHistory((prev) => [...prev, { NameOfClient: "", processes: [], role: "", SlotNo: "" }
]);
    setClientFormValid(false);
  };
  const handleDeleteClient = (index) => {
    handleDeleteItem(index, clientHistory, setClientHistory, clientErrors, setClientErrors, setClientFormValid);
  };


  const handleClientSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateClient(clientHistory);
    setClientErrors(newErrors);

    const noErrors = Object.keys(newErrors).length === 0;
    setClientFormValid(noErrors);

    const sanitizedClientHistory = clientHistory.map(
  ({ __typename, processes, ...client }) => ({
    ...client,
    processes: Array.isArray(processes)
      ? processes.join(", ")
      : processes
  })
);

    const input = {
      client: sanitizedClientHistory,
      clientKey: true,
    };

    try {
      const val = await handleSubmit({
        noErrors,
        formValid: ClientFormValid,
        dataObj: input,
        action: "ClientworkHistory",
        ModalName: "clientModelpopUp",
        submitAction: "handleClientSubmit",
      });
      if (val) {
        dispatch(setClientHistorys(sanitizedClientHistory));
        dispatch(getAllClientsData(sanitizedClientHistory));
        const updatedEmployees = AllEmployees.map((employee) =>
          employee.id === Empid
            ? {
              ...employee,
              client: sanitizedClientHistory
            }
            : employee
        );
        dispatch(SetAllEmployees(updatedEmployees));
        setClientFormValid(false)
      }
    } catch (error) {
    } finally {
      setClientFormValid(false);
    }
  };

  const activeClientOptions = Array.isArray(clientOptions)
  ? clientOptions
      .filter(
        c => c?.status === "Active" || c?.status === "active"
      )
      .map(c => ({
        label: c?.clientName,
        value: c?.clientName,
      }))
  : [];

  const usedClient = Array.isArray(clientHistory)
  ? clientHistory.map(item => item?.NameOfClient).flat()
  : [];

 
  const remainingClientFields = activeClientOptions.filter(
    field => !usedClient.includes(field.value) || field.value === "Others"
  );

  return (
    <Modal
      id="client_history"
      title="Client History"
      handleModalClose={() =>
        handleClose(Client,
          setClientHistory,
          setClientErrors,
          setClientFormValid
        )}
      handleSubmit={handleClientSubmit}
      isUserDataValid={false}
    >
      <div className="form-scroll">
        {clientHistory?.map((client, index) => (
          <div className="card" key={index}>
            <div className="card-body">
              <h3 className="card-title">
                Client Information {index + 1}
                <Link to="#" className="delete-icon" onClick={() => handleDeleteClient(index)}>
                  <i className="fa-regular fa-trash-can" />
                </Link>
              </h3>
              <div className="row">
                <div className="col-md-6 ">
                  <SelectInput
                    label="Name"
                    name="NameOfClient"
                    value={client?.NameOfClient}
                    onChange={(e) => handleClientChange(index, {
                      target: {
                        name: "NameOfClient",
                        value: e
                      }
                    })}
                    formControl={true}
                    options={remainingClientFields}
                    error={clientErrors[index]?.NameOfClient}
                    style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                  />
                </div>
                <div className="col-md-6 ">
                <SelectInput
  formControl={true}
  required={true}
  label="Processes"
  name="processes"
  mode="multiple"
  allowClear
  value={Array.isArray(client?.processes) ? client.processes : []}
  onChange={(value) =>
    handleClientChange(index, {
      target: {
        name: "processes",
        value: Array.isArray(value) ? value : [],
      },
    })
  }
  options={
    Array.isArray(
      getOptionsByPath(
        NestedDatabucket,
        [CLIENT_INFO, CLIENT_SERVICESASSIGNED]
      )
    )
      ? getOptionsByPath(
          NestedDatabucket,
          [CLIENT_INFO, CLIENT_SERVICESASSIGNED]
        )
      : []
  }
  error={clientErrors[index]?.processes}
/>

                </div>
              </div>

              <div className="row">
                <div className="col-md-6 ">
                  <InputField
                    formcontrol="form-control"
                    required={true}
                    type="text"
                    label="Role"
                    className={`form-control ${clientErrors[index]?.role ? 'is-invalid' : ''}`}
                    name="role"
                    value={client?.role || ""}
                    onChange={(e) => handleClientChange(index, e)}
                    error={clientErrors[index]?.role}
                  />
                </div>

                <div className="col-md-6 ">
                  <InputField
                    formcontrol="form-control"
                    required={true}
                    type="text"
                    label="Slot No"
                    className={`form-control ${clientErrors[index]?.SlotNo ? 'is-invalid' : ''}`}
                    name="SlotNo"
                    value={client?.SlotNo || ""}
                    onChange={(e) => handleClientChange(index, e)}
                    error={clientErrors[index]?.SlotNo}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="add-more">
          <Link to="#" onClick={(e) => { e.preventDefault(); addClient(); }}>
            <i className="fa-solid fa-plus-circle" /> Add More
          </Link>
        </div>
      </div>
    </Modal>

  )

}